import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useR2StateContext } from '../../../providers/r2Provider/R2Context'
import { useSharedBrowserStateContext } from '../../../../shared/providers/sharedBrowserProvider/SharedBrowserContext'

/**
 * Example of the sections array produced:
  [
    {
        "id": 0,
        "offset": 0,
        "title": "Item 1"
    },
    {
        "id": 5,
        "offset": 5,
        "title": "Item 2"
    },
  ]
*/
export default function useSections() {
  const { t } = useTranslation()
  const { childGroups } = useR2StateContext()
  const { viewMode } = useSharedBrowserStateContext()

  const sections = useMemo(() => {
    if (!childGroups?.length || viewMode === 'single') return [{ offset: 0 }]

    const toSections = (acc, childGroup, index) => {
      const { childIds, parentId } = childGroup
      const section = {
        id: parentId,
        offset: acc.overallIndex,
        title: t('ImageBrowserViewer.itemNumber', 'Item {itemNumber}', { itemNumber: index + 1 }),
      }
      acc.sections.push(section)
      acc.overallIndex += childIds.length
      return acc
    }
    const initialAccumulator = { sections: [], overallIndex: 0 }

    const sectionsReduction = childGroups.reduce(toSections, initialAccumulator)

    return sectionsReduction.sections
  }, [childGroups, t, viewMode])

  return sections
}
